import {valueof} from "~/model/helperTypes/generic";

export const getEnumValues = <T extends object>(enumObject: T): valueof<T>[] =>
  Object.values(enumObject).filter((value) => typeof value === "string");
